module.exports = __webpack_public_path__ + "img/extra-icon.533fc9c7.png";